export const ATIVIDADES_ACAO = {
  VER_AVISO: 801,
  FAZER_AVISO: 802,
  REMOVER_AVISO: 803,
  VER_ACESSO: 901,
  FAZER_ACESSO: 902,
  REMOVER_ACESSO: 903,
  VER_SAUDE: 1001,
  FAZER_SAUDE: 1002,
  REMOVER_SAUDE: 1003,
  VER_SONINHO: 1101,
  FAZER_SONINHO: 1102,
  REMOVER_SONINHO: 1103,
  VER_ALIMENTACAO: 1201,
  FAZER_ALIMENTACAO: 1202,
  REMOVER_ALIMENTACAO: 1203,
  VER_HIGIENE: 1301,
  FAZER_HIGIENE: 1302,
  REMOVER_HIGIENE: 1303,
} as const;

export const TIPO_PUBLICACAO_RECADO = 80;
export const TIPO_PUBLICACAO_ACESSO = 90;
export const TIPO_PUBLICACAO_SAUDE = 100;
export const TIPO_PUBLICACAO_SONINHO = 110;
export const TIPO_PUBLICACAO_ALIMENTACAO = 120;
export const TIPO_PUBLICACAO_HIGIENE = 130;

export const TIPO_ACESSO = {
  ENTRADA: 0,
  SAIDA: 1,
  FALTA: 2,
} as const;

export const TIPO_SAUDE = {
  MEDICAMENTO: 0,
  PROCEDIMENTO: 1,
} as const;

export const TIPO_SONINHO = {
  DORMIU: 0,
  ACORDOU: 1,
  RECUSOU: 2,
} as const;

export const TIPO_HIGIENE = {
  XIXI: 0,
  COCO: 1,
  XIXI_E_COCO: 2,
  FRALDA_SECA: 3,
} as const;

export const ATIVIDADES_ACOES_MODULO = Object.values(ATIVIDADES_ACAO);

/** VER_* / FAZER_* — mesmo conjunto do GET /v1/publicacoes (sem REMOVER_*). */
export const ATIVIDADES_ACOES_FEED = [
  ATIVIDADES_ACAO.VER_AVISO,
  ATIVIDADES_ACAO.FAZER_AVISO,
  ATIVIDADES_ACAO.VER_ACESSO,
  ATIVIDADES_ACAO.FAZER_ACESSO,
  ATIVIDADES_ACAO.VER_SAUDE,
  ATIVIDADES_ACAO.FAZER_SAUDE,
  ATIVIDADES_ACAO.VER_SONINHO,
  ATIVIDADES_ACAO.FAZER_SONINHO,
  ATIVIDADES_ACAO.VER_ALIMENTACAO,
  ATIVIDADES_ACAO.FAZER_ALIMENTACAO,
  ATIVIDADES_ACAO.VER_HIGIENE,
  ATIVIDADES_ACAO.FAZER_HIGIENE,
] as const;

export function acaoRemoverDoTipo(tipo: number): number | null {
  switch (tipo) {
    case TIPO_PUBLICACAO_RECADO:
      return ATIVIDADES_ACAO.REMOVER_AVISO;
    case TIPO_PUBLICACAO_ACESSO:
      return ATIVIDADES_ACAO.REMOVER_ACESSO;
    case TIPO_PUBLICACAO_SAUDE:
      return ATIVIDADES_ACAO.REMOVER_SAUDE;
    case TIPO_PUBLICACAO_SONINHO:
      return ATIVIDADES_ACAO.REMOVER_SONINHO;
    case TIPO_PUBLICACAO_ALIMENTACAO:
      return ATIVIDADES_ACAO.REMOVER_ALIMENTACAO;
    case TIPO_PUBLICACAO_HIGIENE:
      return ATIVIDADES_ACAO.REMOVER_HIGIENE;
    default:
      return null;
  }
}
